import React, {FC, useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import {Content, Footer} from "../../components/layout";
import {ChildrenProps} from "../../utils";
import {createBorrowingOnboardingManager, createProfileManager} from "../../di";
import {useAppDispatch, useEffectOnMount, useErrorCallback, useLoggedInStatus, useProfileData} from "../../hooks";
import {set, setBorrowerOnboardingComplete} from "../../store/profile";
import {
  AccountNotReadyWarningSection,
  Loader,
  Main,
  ModalContainer,
  Overlay,
  ScrollToTopButton
} from "../../components";
import AlertNotifications from "../../components/alert-notifications/AlertNotifications/AlertNotifications";
import {HeaderBorrower, HeaderLender} from "../../components/layout/HeaderNew";
import {OnboardingStep, Role} from "../../api-client";

const LayoutCabinet: FC<ChildrenProps> = ({children}) => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const isLoggedIn = useLoggedInStatus();
  const errorCallback = useErrorCallback();
  const [loading, setLoading] = useState(true);
  const profileData = useProfileData();
  const {role} = profileData;
  
  const hideWarningSection = location.pathname === '/dashboard/identification-borrower';

  useEffectOnMount(() => {
    const mountCallback = async () => {
      setLoading(true);
      try {
        if (!isLoggedIn) {
          const initSession = async () => {
            await initProfile();
          };
          await initSession();
        }
      } catch (error: any) {
        await errorCallback(error);
      } finally {
        setLoading(false);
      }
    };
    (async () => {
      await mountCallback();
    })();
  });

  const initProfile = async () => {
    const manager = await createProfileManager();
    const profile = await manager.get();
    dispatch(set(profile));
  };

  useEffect(() => {
    if (role !== Role.BORROWER || !profileData.isVerified || profileData.borrowerOnboardingComplete !== null) {
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const manager = await createBorrowingOnboardingManager();
        const state = await manager.get();
        if (!cancelled) {
          dispatch(setBorrowerOnboardingComplete(state.currentStep === OnboardingStep.PROJECT_CREATION));
        }
      } catch {
        if (!cancelled) {
          dispatch(setBorrowerOnboardingComplete(false));
        }
      }
    })();
    return () => {cancelled = true};
  }, [role, profileData.isVerified, profileData.borrowerOnboardingComplete, dispatch]);
  return (
    <Content>
      { loading ? <Loader/> : <>
        {role === Role.LENDER? <HeaderLender/>: <HeaderBorrower/>}
        <Overlay />
        <AlertNotifications />
        <Main>
          {!hideWarningSection && <AccountNotReadyWarningSection/>}
          {children}
        </Main>
        <Footer />
        <ModalContainer />
        <ScrollToTopButton />
      </> }
    </Content>
  );
};

export default LayoutCabinet;